<template>
    <div class="products">
        <div class="container">
            <!-- 静态图片：直接使用模块化引入 -->
            <img src="https://youke1.picui.cn/s1/2025/08/26/68adb80dc6939.png" class="product-image" alt="原鲜冬虫夏草背景图">

            <div class="buy_list">
                <div class="buy_item" v-for="(item, index) in dynamicList" :key="index">
                    <div class="dynamic-inner">
                        <!-- 动态图片：通过 item 中的 imgPath 计算真实路径 -->
                        <div class="dynamic-img">
                            <img :src="item.imgPath" :alt="item.title" loading="lazy">
                        </div>
                        <div class="dynamic-info">
                            <div class="dynamic-name">{{ item.title }}</div>
                            <div class="dynamic-time">{{ item.time }}</div> <!-- 修复原代码拼写错误：tiem → time -->
                            <div class="dynamic-tips">{{ item.tips }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'

// 2. 动态列表：存储图片的「相对路径」（无需写完整 URL，后续统一计算）
// 注意：修复原代码拼写错误「tiem」→「time」
const dynamicList = ref([
    {
        title: "东阳光补己品牌财富论坛聚力伙伴，共赢千亿滋补蓝海",
        time: "2025-07-29",  // 修复拼写错误
        tips: "7月23日，2025东阳光补已品牌财富论坛在湖北宜都盛大举行。百余位行业英齐聚，洞见国民滋养新纪元，掘金大健康产业千亿赛道。",
        imgPath: "https://youke1.picui.cn/s1/2025/08/26/68adb80dc6939.png"  // 仅存相对路径，后续通过方法计算真实路径
    },
    {
        title: "全新冬虫夏草品牌“东阳光补己”重磅发布，开启国民滋养新时代",
        time: "2025-06-22",  // 修复拼写错误
        tips: "7月22日，以“国民滋养·补已时代”为主题的东阳光补已品牌上市发布会在深圳隆重举行，标志着东阳光集团旗下全新冬虫夏草品牌“东阳光补已”正式启航。中医药界权威、经济领域专家、主流媒体代表及核心经销商伙伴齐聚一堂，共同见证了这一滋补行业新势力的诞生。",
        imgPath: "https://youke1.picui.cn/s1/2025/08/26/68adb80c86e68.png"
    },
    {
        title: "东阳光补己品牌财富论坛聚力伙伴，共赢千亿滋补蓝海",
        time: "2025-07-29",  // 修复拼写错误
        tips: "7月23日，2025东阳光补已品牌财富论坛在湖北宜都盛大举行。百余位行业英齐聚，洞见国民滋养新纪元，掘金大健康产业千亿赛道。",
        imgPath: "https://youke1.picui.cn/s1/2025/08/26/68adb80dc6939.png"  // 仅存相对路径，后续通过方法计算真实路径
    },
    {
        title: "东阳光补己品牌财富论坛聚力伙伴，共赢千亿滋补蓝海",
        time: "2025-07-29",  // 修复拼写错误
        tips: "7月23日，2025东阳光补已品牌财富论坛在湖北宜都盛大举行。百余位行业英齐聚，洞见国民滋养新纪元，掘金大健康产业千亿赛道。",
        imgPath: "https://youke1.picui.cn/s1/2025/08/26/68adb80dc6939.png"  // 仅存相对路径，后续通过方法计算真实路径
    },
    {
        title: "东阳光补己品牌财富论坛聚力伙伴，共赢千亿滋补蓝海",
        time: "2025-07-29",  // 修复拼写错误
        tips: "7月23日，2025东阳光补已品牌财富论坛在湖北宜都盛大举行。百余位行业英齐聚，洞见国民滋养新纪元，掘金大健康产业千亿赛道。",
        imgPath: "https://youke1.picui.cn/s1/2025/08/26/68adb80dc6939.png"  // 仅存相对路径，后续通过方法计算真实路径
    },
    {
        title: "东阳光补己品牌财富论坛聚力伙伴，共赢千亿滋补蓝海",
        time: "2025-07-29",  // 修复拼写错误
        tips: "7月23日，2025东阳光补已品牌财富论坛在湖北宜都盛大举行。百余位行业英齐聚，洞见国民滋养新纪元，掘金大健康产业千亿赛道。",
        imgPath: "https://youke1.picui.cn/s1/2025/08/26/68adb80dc6939.png"  // 仅存相对路径，后续通过方法计算真实路径
    },
])

// 3. 核心方法：将「相对路径」转为构建工具可识别的「真实URL」
const getImageUrl = (relativePath) => {
    // new URL(图片相对路径, 当前模块URL)：构建真实资源路径
    return new URL(relativePath, import.meta.url).href
}
</script>

<style scoped>
.products {
    background-color: #F4ECE1;
    min-width: 1350px;
    width: 100%;
}

.container {
    width: 100%;
    margin: 0 auto;
    padding: 1px;
}

.product-image {
    width: 100%;
    height: auto;
    padding-top: 80px;
}

/* 列表容器：移除不必要的 flex-wrap，确保垂直排列 */
.buy_list {
    display: flex;
    flex-direction: column;
    /* 垂直排列列表项 */
    gap: 20px;
    /* 替代 margin-bottom，间距更统一 */
    margin-bottom: 20px;
}

/* 列表项：优化背景和阴影，提升层次感 */
.buy_item {
    background-color: #FFFFFF;
    padding: 30px;


    /* 轻微阴影，区分层级 */
    transition: box-shadow 0.3s ease;
    /*  hover 过渡，更流畅 */
}

/* 列表项 hover：增强交互反馈 */
.buy_item:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

/* 列表项内部：横向布局，图片与文字并排 */
.dynamic-inner {
    display: flex;
    align-items: center;
    gap: 60px;
    /* 图片与文字间距 */
    width: 60%;
    margin: auto;
}

/* 动态图片容器：限制宽度，避免图片过大 */
.dynamic-img {
    width: 200px;
    /* 固定图片区域宽度 */
    flex-shrink: 0;
    /* 防止图片被压缩 */
}

/* 动态图片：保持比例，填充容器 */
.dynamic-img img {
    width: 100%;
    height: 140px;
    object-fit: cover;
}

/* 文字信息区：占据剩余空间 */
.dynamic-info {
    flex: 1;
    /* 填充剩余宽度 */
}

/* 标题样式：优化字号和行高 */
.dynamic-name {
    color: #AC8868;
    font-weight: bold;
    font-size: 20px;
    /* 微调字号，更易阅读 */
    line-height: 1.4;
    margin-bottom: 8px;
}

/* 时间样式：降低对比度，作为辅助信息 */
.dynamic-time {
    color: #8A7968;
    /* 稍浅颜色，区分主次 */
    font-size: 14px;
    margin-bottom: 16px;
}

/* 描述文本：优化行高，提升阅读体验 */
.dynamic-tips {
    color: #534238;
    font-size: 15px;
    line-height: 1.6;
    /* 行高1.6，适合长文本阅读 */
}

/* 响应式：小屏下图片与文字垂直排列 */
@media (max-width: 768px) {
    .dynamic-inner {
        flex-direction: column;
        text-align: center;
        /* 文字居中 */
        gap: 20px;
    }

    .dynamic-img {
        width: 160px;
        /* 小屏下缩小图片宽度 */
        margin: 0 auto;
        /* 图片居中 */
    }

    .dynamic-img img {
        height: 120px;
        /* 小屏下缩小图片高度 */
    }

    .dynamic-name {
        font-size: 18px;
    }

    .dynamic-tips {
        text-align: left;
        /* 描述文本左对齐，更易阅读 */
    }
}

/* 移除未使用的样式：避免冗余（原代码中未使用的按钮、标题样式） */
</style>